import { Link } from "react-router-dom";
const RESORTS = [
    {
        title: "Hiru Villa Ayurveda Resort (Maggona)",
        logo: "/images/Logos/hiru_villa.webp",
        subtitle: "Die ruhige W\xE4rme eines Zuhauses, umh\xFCllt von Tradition und Vertrauen",
        description: "Eingebettet in die atemberaubende Landschaft der s\xFCdwestlichen K\xFCste Sri Lankas, ist Hiru Villa der Ursprung des Hiru Ayurveda Resorts, das 2009 gegr\xFCndet wurde.",
        detail: "18 Zimmer gesamt / kolonialer Charakter \xD7 moderner Komfort",
        image: "/images/Hiru/Hiru Villa's/Drone/DJI_0950-Enhanced-NR-Pano-1-copy.webp",
        href: "/hiru-villa"
    },
    {
        title: "Hiru Om Ayurveda Resort (Maggona)",
        logo: "/images/Logos/hiru_om.webp",
        subtitle: "Ein heiliger Bodhi-Baum erwartet Sie \u2013 ein verstecktes Refugium mit 12 Zimmern.",
        description: "Im Garten von Hiru Om steht still und majest\xE4tisch ein Bodhi-Baum, das Symbol des Resorts. Er stammt von einem heiligen Baum in Anuradhapura, Sri Lanka, der \xFCber 2.000 Jahre alt ist und Frieden und Erleuchtung symbolisiert.",
        detail: "Selbst gepfl\xFCcktes Gem\xFCse aus dem eigenen Garten \u2192 besondere Chef-Koch-Erfahrung vor Ort",
        image: "/images/OM Edited/DSC02376.webp",
        href: "/hiru-om"
    },
    {
        title: "Hiru Mudra Ayurveda Resort (Induruwa)",
        logo: "/images/Logos/hiru_mudra.webp",
        subtitle: "Luxus mit nur 11 Zimmern. Ein ruhiger Strandurlaub, nur begleitet vom Klang der Wellen.",
        description: "An der unber\xFChrten K\xFCste von Induruwa, wo die Natur noch unverf\xE4lscht ist, steht Hiru Mudra \u2013 ein ruhiger Ayurveda-R\xFCckzugsort f\xFCr Erwachsene, der Stil und Stille in Einklang bringt.",
        detail: "Privater Strand direkt vor der T\xFCr / atemberaubende Aussicht von der Dachterrasse",
        image: "/images/Mudra Edited/DSC02205.webp",
        href: "/hiru-mudra"
    },
    {
        title: "Hiru Aadya Ayurveda Resort (Ahungalla)",
        logo: "/images/Logos/hiru_adya.webp",
        subtitle: "Im Oktober 2025 er\xF6ffnete Hiru Aadya als neues Highlight der Hiru Group in Ahungalla.",
        description: "Ein ruhiges, verstecktes Resort am sanft geschwungenen Meer an der Golden Mile Beach, die sich \xFCber 3 km erstreckt.",
        detail: "11 Zimmer mit Ozeanblick",
        image: "/images/Hiru Aadya.webp",
        href: "/hiru-aadya"
    }
];
const OurResorts = () => {
    return <section className="relative w-full overflow-hidden py-16 sm:py-20 lg:py-28">
        <img
            src="/images/Hiru/hiru-villa.webp"
            alt="Hintergrundbild des Hiru Resorts" className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75" />

        <div className="relative z-10 container mx-auto px-4">
            <div className="mx-auto mb-14 max-w-3xl text-center">

                <h2 className="font-serif text-3xl font-light text-white drop-shadow-lg sm:text-4xl lg:text-5xl">
                    Fünf ruhige Rückzugsorte, die wie Zuhause wirken
                </h2>
            </div>

            <div className="grid grid-cols-1 gap-x-8 gap-y-20 pt-16 lg:grid-cols-2 lg:gap-y-32">
                {RESORTS.map((resort, index) => <article
                    key={index}
                    className="group relative flex h-full flex-col overflow-visible rounded-[2rem] border border-white/15 bg-white/10 shadow-[0_30px_80px_rgba(0,0,0,0.22)] backdrop-blur-xl transition-transform duration-300 hover:-translate-y-1 hover:bg-white/12"
                >
                    <div className="absolute left-6 top-0 z-20 h-32 w-32 -translate-y-1/2 overflow-visible sm:h-28 sm:w-28 lg:h-48 lg:w-48">
                        <img
                            src={resort.logo}
                            alt={`${resort.title} logo`} className="object-contain" style={{ position: "absolute", inset: 0, width: "100%", height: "90%" }} loading="lazy" />
                    </div>

                    <div className="relative h-80 overflow-hidden rounded-t-[2rem]">
                        <img
                            src={resort.image}
                            alt={resort.title} className="object-cover"
                            loading="lazy" style={{ position: "absolute", inset: 0, width: "100%", height: "90%" }} />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-transparent" />
                    </div>
                    <div className="flex flex-1 flex-col p-8 text-white">
                        <div className="mb-6">
                            <h3 className="mb-3 font-serif text-2xl font-semibold text-white">
                                {resort.title}
                            </h3>
                            <p className="mb-4 text-sm uppercase tracking-[0.35em] text-amber-100/90">
                                {resort.subtitle}
                            </p>
                            <p className="leading-relaxed text-white/82">{resort.description}</p>
                        </div>
                        <div className="mt-auto">
                            <p className="mb-6 font-medium text-white/90">{resort.detail}</p>
                            <Link
                                to={resort.href}
                                className="inline-flex w-full items-center justify-center rounded-full border border-amber-200/25 bg-gradient-to-r from-[#F28600] to-[#ff9a1f] px-6 py-3 text-sm font-semibold text-white shadow-[0_18px_50px_-22px_rgba(242,134,0,0.9)] transition hover:translate-y-[-1px] hover:from-[#ff9814] hover:to-[#f28600]"
                            >
                                Mehr erfahren
                            </Link>
                        </div>
                    </div>
                </article>)}
            </div>
        </div>
    </section>;
};
export default OurResorts;
